import { CartNameSpace } from 'core/constant/CartNameSpace';
import { selectCmsFromBootstrap, selectConfigFromBootstrap, selectPageTypeIdFromBootstrap } from 'store/slice/bootstrap';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { createSelector } from '@reduxjs/toolkit';
import { CrossSellWidgetState } from '@cart-js/trip';
import { CmsValue } from 'core/type/BootstrapConfig.types';

export interface StateProps {
    pageTypeId: ActivitiesPageTypes;
    topDestinationCityId?: number;
    cms: CmsValue;
}

export interface OwnProps {
    namespace: CartNameSpace;
    onCartResponseFailure: () => void;
}

export interface TripStateProps {
    apiLoadingState: string;
}

export type HomeCrossSellFallbackComponentProps = StateProps & TripStateProps & OwnProps;

export const mapStateToProps = createSelector(selectPageTypeIdFromBootstrap, selectConfigFromBootstrap, selectCmsFromBootstrap, (pageTypeId, bootStrapConfig, cms) => ({
    pageTypeId,
    topDestinationCityId: bootStrapConfig.geo?.topDestinationCityId,
    cms,
}));

export const mapTripStateToProps = (state: CrossSellWidgetState, ownProps: OwnProps): TripStateProps => {
    return {
        apiLoadingState: state?.data?.[ownProps.namespace.toString()]?.GetSimpleRecommendations?.status ?? 'Initial',
    };
};
